import { StyledLoadingPlaceholder } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledContentWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;

  p[data-title='title'] {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    margin-bottom: 0.8rem;
  }
`;

export const StyledSkillsMatrixPlaceholder = styled.div`
  ${StyledLoadingPlaceholder}
  height: 32.5rem;
  width: min(66.8rem, 100%);
  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    height: 28.5rem;
    width: 100%;
  }
`;

export const StyledSkillsMatrixImage = styled.img`
  margin: 1.2rem 0;
  width: auto;
  height: 32.5rem;
  object-fit: contain;
  border-radius: 0.5rem;
  @media (max-width: ${({ theme }) => theme.sizes.lg}) {
    height: unset;
    width: 100%;
  }
`;

export const StyledShareSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
`;
